import * as React from "react";
import { Typography } from "@mui/material";


const FilterResultText: React.FC = (props) => {
    return (
        <Typography variant="body2">
            <b>
                {props.children}
            </b>
        </Typography>
    );
}

export default FilterResultText;
